import { AppSelectBox } from 'components';
import { Fragment } from 'react';

function StatusDropDown({
  value,
  handleChange,
  isClass = false,
  fieldErrors = {},
  className = '',
}) {
  return (
    <AppSelectBox
      labelProps={{ label: 'Status' }}
      selectProps={{
        value,
        onChange: handleChange,
        className,
      }}
      fieldErrors={fieldErrors}
    >
      <option disabled value="">
        Choose
      </option>
      <option value="active">Active</option>
      <option value="inactive">Inactive/Draft</option>
      {isClass && (
        <Fragment>
          <option value="archive">Archive</option>
          <option value="deactivate">Deactivate</option>
        </Fragment>
      )}
    </AppSelectBox>
  );
}

StatusDropDown.defaultProps = {
  handleChange: () => {},
};

export default StatusDropDown;
